import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VacationRequestStatus } from '@work4all/models/lib/Enums/VacationRequestStatus.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function VacationStatusPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(VacationRequestStatus)
      .map((key) => {
        const id = VacationRequestStatus[key];

        return {
          id,
          name: t(`APPROVAL_CENTER.VACATION.STATUS.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
